import React from "react";

const SubmitButton = ({submit}) => {
    return(
        <button id="SubmitButton" onClick={submit}>Submit</button>
    );
}

export default SubmitButton;